import * as AdminConstants from "../constants/admin-constants";

const initialState = {
  loading: false,
  usersError: false,
  errorMessage: "",
  errorStatus: 0,
  errorType: null,
  usersData: [],
  reportData: {},
  weeklyUsers: [],
  totalUsers: []
};

export const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    case AdminConstants.FETCH_USERS_BEGIN:
      return {
        ...state,
        loading: true,
        usersError: false
      };
    case AdminConstants.FETCH_USERS_SUCCESS:
      return {
        ...state,
        usersData: action.data,
        loading: false,
        usersError: false
      };
    case AdminConstants.FETCH_USERS_FAILURE:
      return {
        ...state,
        errorType: action.error.errorType,
        errorMessage: action.error.errorMessage,
        usersError: true,
        loading: false
      };
      //get reports
      case AdminConstants.FETCH_REPORT_BEGIN:
      return {
        ...state,
        loading: true,
        usersError: false
      };
    case AdminConstants.FETCH_REPORT_SUCCESS:
      return {
        ...state,
        reportData: action.data.data,
        loading: false,
        usersError: false
      };
    case AdminConstants.FETCH_REPORT_FAILURE:
      return {
        ...state,
        errorType: action.error.errorType,
        errorMessage: action.error.errorMessage,
        usersError: true,
        loading: false
      };
      default: 
      return {
          ...state
      }
  }
};
